module.exports = __webpack_public_path__ + "img/ic_swipe_chat.77b2e16b.svg";